import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  textareaWrap: {
    position: 'relative',
    marginTop: 16,
  },
  textarea: {
    width: '100%',
    minHeight: 140,
    border: '1px solid #EAECF0',
    padding: 12,
    outline: 'none',
    resize: 'vertical',
    borderRadius: 4,
    fontSize: 14,
  },
  counter: {
    position: 'absolute',
    right: 8,
    bottom: 8,
    fontSize: 12,
    color: '#A3A3A3',
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 8,
  },
  checkboxLabel: {
    fontSize: 14,
  },
  prevHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 16,
    cursor: 'pointer',
  },
  chevron: {
    marginLeft: 8,
  },
  prevList: {
    background: '#F5F5F5',
    padding: 16,
    marginTop: 8,
  },
  prevItem: {
    background: '#F5F5F5',
    padding: 16,
  },
  prevItemLeft: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: '50%',
  },
  prevMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  prevItemRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  toggleLabel: {
    fontSize: 14,
  },
  prevContent: {
    marginTop: 8,
  },
  divider: {
    height: 1,
    background: '#E5E5E5',
    marginTop: 16,
  },
}));

export default useStyles;
